import TrackingService from 'services/TrackingService';
import RecaptchaTrackingBase from 'recaptcha-web-client/RecaptchaTrackingBase';

const actionName = Object.freeze({
    RECAPTCHA_FAILURE: 'trackCaptchaFailure',
    RECAPTCHA_SUCCESS: 'trackCaptchaSuccess',
    RECAPTCHA_VERIFY: 'trackCaptchaVerify',
    RECAPTCHA_VIEW: 'trackCaptchaView',
});

export default class RecaptchaTracking extends RecaptchaTrackingBase {
    /**
     * RecaptchaTrackingVue constructor
     */
    constructor() {
        super();
        this.trackingService = new TrackingService();
    }

    /**
     * Track recaptcha view action
     * @throws Error if tracking service is not set
     */
    view() {
        this.checkIfTrackingServiceIsSet();
        this.trackingService.trackAction(
            actionName.RECAPTCHA_VIEW,
            {
                captchaEventView: 1,
            },
            true,
        );
    }

    /**
     * Track recaptcha verified action
     * @throws Error if tracking service is not set
     */
    verified() {
        this.checkIfTrackingServiceIsSet();
        this.trackingService.trackAction(
            actionName.RECAPTCHA_VERIFY,
            {
                captchaEventVerify: 1,
            },
            true,
        );
    }

    /**
     * Track recaptcha success action
     * @throws Error if tracking service is not set
     */
    success() {
        this.checkIfTrackingServiceIsSet();
        this.trackingService.trackAction(
            actionName.RECAPTCHA_SUCCESS,
            {
                captchaEventSuccess: 1,
            },
            true,
        );
    }

    /**
     * Track recaptcha failure action
     * @throws Error if tracking service is not set
     */
    failure() {
        this.checkIfTrackingServiceIsSet();
        this.trackingService.trackAction(
            actionName.RECAPTCHA_FAILURE,
            {
                captchaEventFail: 1,
            },
            true,
        );
    }

    /**
     * Check if tracking service is set
     * @throws Error if tracking service is not set
     */
    checkIfTrackingServiceIsSet() {
        if (!this.trackingService || typeof this.trackingService !== 'object') {
            throw new Error('Tracking service is not set');
        }
    }
}
